<template>
  <div class="courses-cards">
    <div class="main-title">
      <h2>выбери свое обучение</h2>
    </div>

    <div class="courses-cards__tabs">
      <button
        v-for="(item, idx) of tabs"
        :key="`tabItem${idx + 1}`"
        :class="[
          'courses-cards__tabs--item',
          {'courses-cards__tabs--item-active': item === activeTab},
        ]"
        @click="changeActiveTab(item)"
      >
        {{ item }}
      </button>
    </div>

    <div class="courses-cards__list">
      <div
        v-for="item of filteredCards"
        :key="item.id"
        class="courses-cards__item"
      >
        <div class="courses-cards__item--top">
          <img
            :src="item.image"
            :alt="item.title"
            class="courses-cards__item--image"
          >

          <div class="courses-cards__item--top-content">
            <ul v-if="item.chips && item.chips.length">
              <li
                v-for="(chips, idx) of item.chips"
                :key="`itemChips${idx + 1}`"
              >
                {{ chips }}
              </li>
            </ul>

            <h6
              v-html="item.title"
            />

            <p
              v-if="item.description"
              v-html="item.description"
            />
          </div>
        </div>

        <div class="courses-cards__item--bottom">
          <p class="courses-cards__item--content">
            {{ item.content }}
          </p>

          <div class="courses-cards__item--price">
            <h6 v-if="item.price && item.price.free">
              бесплатно
            </h6>

            <p v-if="item.price && item.price.description">
              {{ item.price.description }}
            </p>
          </div>

          <nuxt-link
            :to="item.cardLink"
            class="courses-cards__item--link"
          >
            узнать подробнее
          </nuxt-link>

          <button
            class="courses-cards__item--button"
            @click="openModal(`${item.title} ${item.description}`)"
          >
            получить доступ
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import { MODAL_TYPES } from '@/components/v2/common/AppHeader/data';
import {
  CATALOG_COURSES_CATEGORIES,
  CATALOG_COURSES_CARDS,
} from './catalogCards';

export default {
  name: 'CatalogCoursesCards',

  data: () => ({
    activeTab: 'все курсы',
  }),
  computed: {
    tabs() {
      return [
        'все курсы',
        ...Object.values(CATALOG_COURSES_CATEGORIES),
      ];
    },
    filteredCards() {
      if (this.activeTab !== 'все курсы') {
        return CATALOG_COURSES_CARDS.filter(({ filter }) => filter === this.activeTab);
      }

      return CATALOG_COURSES_CARDS;
    },
    routeQuery() {
      return this.$route?.query;
    },
  },
  watch: {
    routeQuery(newVal) {
      this.updateFilterByQuery(newVal);
    },
  },
  created() {
    this.updateFilterByQuery(this.routeQuery);
  },
  methods: {
    ...mapActions('appHeaderModals', {
      storyOpenModal: 'openModal',
      setModalComment: 'setModalComment',
    }),
    openModal(modalComment) {
      this.storyOpenModal(MODAL_TYPES.catalogCourses);
      this.setModalComment(modalComment.replace(/<\/?[^>]+(>|$)/g, ''));
    },
    updateFilterByQuery(value) {
      if ('physics' in value) {
        this.activeTab = CATALOG_COURSES_CATEGORIES.physics;
      }
      if ('language' in value) {
        this.activeTab = CATALOG_COURSES_CATEGORIES.language;
      }
      if ('humanitarian' in value) {
        this.activeTab = CATALOG_COURSES_CATEGORIES.humanitarian;
      }
      if ('socialEconomy' in value) {
        this.activeTab = CATALOG_COURSES_CATEGORIES.socialEconomy;
      }
    },
    changeActiveTab(value) {
      this.activeTab = value;

      const filteredQuery = Object
        .fromEntries(
          Object.entries(this.$route.query).filter(([key]) => !Object.keys(CATALOG_COURSES_CATEGORIES).includes(key)),
        );

      if (Object.keys(filteredQuery).length !== Object.keys(this.$route.query).length) {
        this.$router.replace({ query: filteredQuery });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.courses-cards {
  &__tabs {
    width: calc(100% + var(--scale) * 80);
    margin-left: calc(-1 * var(--scale) * 40);
    padding-inline: calc(var(--scale) * 40);
    margin-top: calc(var(--scale) * 40);
    overflow: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;

    display: flex;
    gap: calc(var(--scale) * 8);

    @include media-down($size-tablet) {
      margin-top: calc(var(--scale) * 24);

      gap: calc(var(--scale) * 4);
    }

    &--item {
      display: flex;
      align-items: center;
      justify-content: center;
      height: calc(var(--scale) * 99);
      padding: 0 calc(var(--scale) * 54);

      border: none;
      border-radius: calc(var(--scale) * 200);
      background-color: $white-color;

      font-size: calc(var(--scale) * 32);
      font-weight: 500;
      line-height: 110%;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      white-space: nowrap;
      color: #A7ABAC;

      cursor: pointer;
      transition: background-color .2s ease-out, color .2s ease-out;

      @include media-down($size-tablet) {
        height: calc(var(--scale) * 52);
        padding: 0 calc(var(--scale) * 22);

        font-size: calc(var(--scale) * 18);
      }

      &:hover, &-active {
        background-color: #5237E6;
        color: $white-color;
      }
    }
  }

  &__list {
    margin-top: calc(var(--scale) * 40);

    display: flex;
    flex-wrap: wrap;
    column-gap: calc(var(--scale) * 20);
    row-gap: calc(var(--scale) * 80);

    @include media-down($size-tablet) {
      column-gap: calc(var(--scale) * 8);
      row-gap: calc(var(--scale) * 40);
    }

    @include media-down($size-mobile) {
      margin-top: calc(var(--scale) * 20);
    }
  }

  &__item {
    width: calc(25% - (var(--scale) * 60) / 4);
    overflow: hidden;

    background-color: $white-color;
    border-radius: calc(var(--scale) * 40);

    @include media-down($size-tablet) {
      width: calc(50% - (var(--scale) * 8) / 2);

      border-radius: calc(var(--scale) * 32);
    }

    @include media-down($size-mobile) {
      width: 100%;
    }

    &--top {
      position: relative;

      &-content {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        padding: calc(var(--scale) * 20);

        @include media-down($size-tablet) {
          padding: calc(var(--scale) * 16.36);
        }
      }

      ul {
        display: flex;
        gap: calc(var(--scale) * 2);

        @include media-down($size-tablet) {
          gap: calc(var(--scale) * 1.64);
        }

        li {
          padding: calc(var(--scale) * 8)
          calc(var(--scale) * 14)
          calc(var(--scale) * 10)
          calc(var(--scale) * 14);
          box-sizing: border-box;

          border: calc(var(--scale) * 1) solid rgba($white-color, .5);
          border-radius: calc(var(--scale) * 40);
          backdrop-filter: blur(22px);

          font-size: calc(var(--scale) * 16);
          font-weight: 500;
          line-height: 130%;
          text-align: left;
          text-underline-position: from-font;
          text-decoration-skip-ink: none;
          color: $white-color;

          @include media-down($size-tablet) {
            padding: calc(var(--scale) * 6.54)
            calc(var(--scale) * 11.45)
            calc(var(--scale) * 8.18)
            calc(var(--scale) * 11.45);

            font-size: calc(var(--scale) * 14);
          }
        }
      }

      h6 {
        margin-top: calc(var(--scale) * 8);

        font-size: calc(var(--scale) * 48);
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -0.02em;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: $white-color;

        @include media-down($size-tablet) {
          margin-top: calc(var(--scale) * 6.54);

          font-size: calc(var(--scale) * 40);
          letter-spacing: -0.04em;
        }
      }

      p {
        font-size: calc(var(--scale) * 26);
        font-weight: 500;
        line-height: 120%;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: $white-color;

        @include media-down($size-tablet) {
          font-size: calc(var(--scale) * 20);
          line-height: 110%;
          letter-spacing: -0.02em;
        }
      }
    }

    &--image {
      width: 100%;
    }

    &--bottom {
      padding: calc(var(--scale) * 16)
      calc(var(--scale) * 20)
      calc(var(--scale) * 20)
      calc(var(--scale) * 20);

      @include media-down($size-tablet) {
        padding: calc(var(--scale) * 12)
        calc(var(--scale) * 8)
        calc(var(--scale) * 8)
        calc(var(--scale) * 8);
      }
    }

    &--content {
      display: -webkit-box;

      font-size: calc(var(--scale) * 16);
      font-weight: 400;
      line-height: 130%;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      color: #02120F;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;

      @include media-down($size-tablet) {
        padding: 0 calc(var(--scale) * 8);

        font-size: calc(var(--scale) * 14);
      }
    }

    &--price {
      margin-top: calc(var(--scale) * 19.5);

      @include media-down($size-tablet) {
        margin-top: calc(var(--scale) * 17.5);

        padding: 0 calc(var(--scale) * 8);
      }

      h6 {
        font-size: calc(var(--scale) * 64);
        font-weight: 500;
        line-height: 95%;
        letter-spacing: -0.02em;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: #02120F;

        @include media-down($size-tablet) {
          font-size: calc(var(--scale) * 48);
          line-height: 110%;
        }
      }

      p {
        font-size: calc(var(--scale) * 16);
        font-weight: 400;
        line-height: 130%;
        letter-spacing: -0.02em;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: #A7ABAC;

        @include media-down($size-tablet) {
          color: #02120F;
        }
      }
    }

    &--link {
      margin: calc(var(--scale) * 23.5) auto 0;
      display: block;

      font-size: calc(var(--scale) * 20);
      font-weight: 400;
      line-height: 130%;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      text-align: center;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        margin: calc(var(--scale) * 21.5) auto 0;

        font-size: calc(var(--scale) * 18);
        line-height: 120%;
      }
    }

    &--button {
      margin-top: calc(var(--scale) * 11);

      display: flex;
      align-items: center;
      justify-content: center;

      width: 100%;
      height: calc(var(--scale) * 71);

      border: none;
      border-radius: calc(var(--scale) * 24);
      background-color: #FF5319;

      font-size: calc(var(--scale) * 26);
      font-weight: 500;
      line-height: 120%;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      color: $white-color;

      cursor: pointer;
      transition: background-color .2s ease-out;

      @include media-down($size-tablet) {
        margin-top: calc(var(--scale) * 13);

        height: calc(var(--scale) * 71);

        font-size: calc(var(--scale) * 18);
      }

      &:hover {
        background-color: #ff9c12;
      }
    }
  }
}
</style>
